import { ChangeEvent, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import WatchLater from "@material-ui/icons/WatchLater";
import TabPanels from "../../../../components/tabpanels";
import TabPanel from "../../../../components/tabpanel";
import QueueListTabPanel from "./queue/list";
import GuicheListTabPanel from "./guiche/list";
import ScheduleListTabPanel from "./schedule/list";
import { useSearchParams } from "../../../../../../../../../hooks/useSearchParams";
import { useDepartmentDetailsTabsStyles } from "./styles";
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import { AttendanceLocalDepartment } from "../../../../../../../../../@types/attendance-local-department";

type DetailsTabsProps = {
    department: AttendanceLocalDepartment;
}

export default function DetailsTabs({ department }: DetailsTabsProps) {
    const history = useHistory();
    const { pathname } = useLocation();
    const { classes } = useDepartmentDetailsTabsStyles();
    const searchParams = useSearchParams();

    const value = useMemo(() => {
        const tab = Number(searchParams.get('active_tab'));
        if (isNaN(tab) || tab < 0 || tab > 3) {
            return 0;
        }
        return tab;
    }, [searchParams]);

    const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
        history.replace(`${pathname}?active_tab=${newValue}`);
    };

    return (
        <Box>
            <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="disabled tabs example"
            >
                <Tab label="Filas" icon={<FormatListBulleted />} classes={{ root: classes.tabRoot }} />
                <Tab label="Horários" icon={<WatchLater />} classes={{ root: classes.tabRoot }} />
                <Tab label="Guichês" icon={<DesktopWindows />} classes={{ root: classes.tabRoot }} />
            </Tabs>
            <TabPanels>
                <TabPanel value={value} index={0}>
                    <QueueListTabPanel />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ScheduleListTabPanel />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <GuicheListTabPanel />
                </TabPanel>
            </TabPanels>
        </Box>
    );
}